module.exports = __webpack_public_path__ + "media/icons/three-dots-ba0cc007.svg";